export default __webpack_public_path__ + "static/media/jack_of_hearts2.f623f209.png";